import db from '../../utils/db'
import {get} from '../../utils/auth'
const pageOpendDefault = {
  // meta: {
  //   title: '首页'
  // },
  // name: 'dashboard',
  // path: 'dashboard'
}
const tagsView = {
  state: {
    visitedViews: [],
    cachedViews: [],
    pageOpenedList: [
      pageOpendDefault
    ],
    pagePool: [],
    pageCurrent: ''
  },
  mutations: {
    ADD_VISITED_VIEWS: (state, view) => {
      // 排除掉嵌入式报表的
      if (
        state.visitedViews.find(
          v => { if (v.path !== "/production/iframe") {
            return v.path === view.path
          } else {
            return v.title === view.query.name 
          }
        }
        )
      ) return
      state.visitedViews.push({
        name: view.name,
        path: view.path,
        title: view.path === '/production/iframe' ? view.query.name || '报表查询' : view.meta.title || 'no-name'
      })
      if (view.meta.keepAlive) {
        state.cachedViews.push(view.name)
      }
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    DB (state, key) {
      const row = db.get(key).find({token: get('token')})
      if (row.value()) {
        row.assign({value: state[key]}).write()
      } else {
        db.get(key).push({
          token: get('token'),
          value: state[key]
        }).write()
      }
    },
    GET_DB_BY_TOKEN (state, {key, defaultValue, handleFunction}) {
      const row = db.get(key).find({token: get('token')}).value()
      const handle = handleFunction || (res => res)
      state[key] = row ? handle(row.value) : defaultValue
    },
    SUCCESS_LOAD (state) {
      this.commit('OPEND_LIST_LOAD')
    },
    OPEND_LIST_LOAD () {
      this.commit('GET_DB_BY_TOKEN', {
        key: 'pageOpenedList',
        defaultValue: [
          pageOpendDefault
        ]
      })
    },
    CURRENT_SET (state, name) {
      state.pageCurrent = name
    },
    POOL_SET (state, pool) {
      state.pagePool = pool
    },
    UPDATE_TAG (state, {index, params, query}) {
      let page = state.pageOpenedList[index]
      page.params = params || page.params
      page.query = query || page.query
      state.pageOpenedList.splice(index, 1, page)
      this.commit('DB', 'pageOpenedList')
    },
    ADD_TAG_CREATE (state, {tag, params, query}) {
      let newPage = tag
      newPage.params = params || newPage.params
      newPage.query = query || newPage.query
      state.pageOpenedList.push(newPage)
      this.commit('DB', 'pageOpenedList')
    },
    PAGE_OPEN_NEW (state, { name, params, query }) {
      let pageOpenedList = state.pageOpenedList
      let pageOpenIndex = 0
      const pageOpend = pageOpenedList.find((page, index) => {
        let same = page.name === name
        // 如果是报表的话 根据报表的title查找
        if (name === 'iframe') {
           same = page.reporttitle === query.reporttitle
        }
        pageOpenIndex = same ? index : pageOpenIndex
        return same
      })
      if (pageOpend) {
        this.commit('UPDATE_TAG', {index: pageOpenIndex, params, query})
      } else {
        let tag = state.pagePool.find(t => t.name === name)
        // 单独处理报表
        if (name === 'iframe') {
          tag = {
            name: 'iframe',
            reporttitle: query.reporttitle, 
            meta: { title: `${query.reporttitle || '报表查询'}`, keepAlive: true }
          } 
        }
        if (tag) {
          this.commit('ADD_TAG_CREATE', { tag, params, query })
        }
      }
    },
    CLOSE_PAGE (state, {tagName, vm, targetName}) {
      let newPage = state.pageOpenedList[0]
      const isCurrent = state.pageCurrent === tagName
      const index = state.pageOpenedList.findIndex(page => page.name === tagName)
      if (isCurrent) {
        let len = state.pageOpenedList.length
        for (let i = 1; i < len; i++) {
          if (state.pageOpenedList[i].name === tagName) {
            if (i < len - 1) {
              newPage = state.pageOpenedList[i + 1]
            } else {
              newPage = state.pageOpenedList[i - 1]
            }
            break
          }
        }
      }
      if (index >= 0) {
        state.pageOpenedList.splice(index, 1)
      }
      const { name = '', params = {}, query = {} } = newPage
      if (isCurrent) {
        let routerObj = {
          name,
          params,
          query
        }
        if (targetName) {
          let targetRoute = state.pageOpenedList.find((page) => {
             return page.name === targetName
          })
          routerObj = {
            name: targetName,
            params: targetRoute.params,
            query: targetRoute.query
          }
        }
        vm.$router.push(routerObj)
      }
    }
  },
  actions: {
    addTageCreate ({commit}, view) {
      commit()
    },
    addVisitedViews ({commit}, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews ({commit, state}, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    }
  },
  getters: {
    keepAliveInclude (state) {
      return state.pageOpenedList.filter(item => {
        if (item.meta) {
          return item.meta.keepAlive
        }
      }).map(e => e.name)
    }
  }
}
export default tagsView
